import React, { useState, useEffect, useRef } from 'react';

import PortalItem from "@arcgis/core/portal/PortalItem";

const InfoButton = () => {
  const [modalOpen, setModalOpen] = useState(undefined);
  const modalTextRef = useRef("") 

  useEffect(() => {
    window.addEventListener('calciteModalClose', handleModalClose);

    getModalText();

    // cleanup this component
    return () => {
      window.removeEventListener('calciteModalClose', handleModalClose);
    };
  }, []);

  const handleModalOpen = () => {
      setModalOpen(true);
  }

  const handleModalClose = () => {
    setModalOpen(undefined);
  }

  const getModalText = () => {
    var item = new PortalItem({
      id: "895f4bfb8815440e83033d32cd379d7f"
    });

    item.load().then(function() {
      // using Ref to set the innerHTML text so that all HTML tags are displayed same as in the portal item
      modalTextRef.current.innerHTML = item.description;
    });

  }

  return (
    <>
      <calcite-button
        title="About the Climate Explorer"
        appearance="transparent"
        color="inverse"
        scale="m"
        href=""
        icon-start="information"
        alignment="center"
        width="auto"
        onClick={handleModalOpen}
      ></calcite-button>

      <calcite-modal
        active={modalOpen}
        color=""
        background-color="white"
        scale="m"
        width="s"
        intl-close="Close"
        aria-describedby="modal-describedby"
        aria-labelledby="modal-labelledby"
        aria-modal="true"
        role="dialog"
      >
        <h3 slot="header" id="div-header">
          Welcome to Climate Explorer !
        </h3>
        <div slot="content" id="div-content" style={{color: 'black'}} ref={modalTextRef}></div>
      </calcite-modal>
    </>
  );
}

export default InfoButton;
